import { render, staticRenderFns } from "./TransferSalesReport.vue?vue&type=template&id=b32a2424&scoped=true"
import script from "./TransferSalesReport.vue?vue&type=script&lang=js"
export * from "./TransferSalesReport.vue?vue&type=script&lang=js"
import style0 from "./TransferSalesReport.vue?vue&type=style&index=0&id=b32a2424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32a2424",
  null
  
)

export default component.exports